// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowCard-cls1_Ddx","cls2":"BulkFollowCard-cls2_LrN BulkFollowCard-cls1_Ddx"};